export interface Bonus {
  title: string
  description: string
  value: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Das Jahreszeiten-Liederbuch',
    description:
      'Lieder und Klassenbeiträge für jeden Anlass vom Schulanfang bis zur Abschlussfeier.',
    value: '39 €',
  },
  {
    title: 'Die Bodypercussion-Schule',
    description:
      '50 fertige Rhythmen nur mit dem Körper, für Klassen ohne Instrumente.',
    value: '29 €',
  },
  {
    title: 'Die Musikspiele-Kartei',
    description:
      '60 Spiele für 5 Minuten Musik zum Ankommen, zwischendurch oder zum Stundenende.',
    value: '29 €',
  },
  {
    title: 'Das Poster-Paket',
    description:
      '12 Plakate für den Musikraum, einmal aufhängen, das ganze Jahr nutzen.',
    value: '24 €',
  },
  {
    title: 'Schulkonzert & Elternabend',
    description:
      'Auftritte stressfrei planen und Eltern überzeugend informieren.',
    value: '19 €',
  },
  {
    title: 'Fachfremd Musik unterrichten',
    description:
      'Der Survival-Guide für mehr Sicherheit im Fach, auch ohne Musikstudium.',
    value: '19 €',
  },
]
